import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { WholesalerEntity } from './wholesaler.entity';

@Index('client_wholesaler__fk_wholesaler__id_fk', ['fkWholesalerId'], {})
@Index('client_wholesaler_pk', ['fkClientId', 'fkWholesalerId'], {
	unique: true,
})
@Entity('client_wholesaler')
export class ClientWholesalerEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: '_fk_wholesaler__id', unsigned: true })
	public fkWholesalerId!: number;

	@Column('varchar', { name: 'tier', nullable: false, length: 255 })
	public tier!: string;

	@ManyToOne(() => ClientEntity, (client) => client.clientWholesalers, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(
		() => WholesalerEntity,
		(wholesaler) => wholesaler.clientWholesalers,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_wholesaler__id', referencedColumnName: 'id' }])
	public fkWholesaler!: WholesalerEntity;
}
